module.exports = __webpack_public_path__ + "img/vertical_6_1_7042.addd0fb4.png";